import { Spinner } from 'reactstrap';
import { useTranslator } from '@front-activerse/common-components';
import Layout from './Layout';
import TitleBar from './TitleBar';

export const UniversalPlaceholder = ({
  fullHeightMinusHeader = false,
  titleBar = '',
  simpleLayout = false,
}) => {
  const { t } = useTranslator();

  const getClassName = () => {
    if (fullHeightMinusHeader) {
      return 'full-height2';
    }
    if (titleBar) {
      return 'full-height3';
    }

    return 'full-height';
  };
  return (
    <Layout simpleLayout={simpleLayout}>
      {titleBar && <TitleBar showBackBtn={false}>{t(titleBar)}</TitleBar>}

      <div className={getClassName()}>
        <div className="loader-wrapper no-fixed">
          <Spinner color="primary">{t('loading.message')}</Spinner>
        </div>
      </div>
    </Layout>
  );
};

export default UniversalPlaceholder;
